import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION30: PdfComponent = {
  type: 'section',
  id: 's30',
  title: '30. Equitable Reflief',
  content: [
    {
      type: 'altText',
      id: 's30bullets',
      content: [
        'The Subscriber recognises that any breach or threatened breach of this Agreement may cause Kanda irreparable harm for which damages may not be an adequate remedy. Accordingly, in addition to any other remedies and damages available to Kanda, the Subscriber acknowledges and agrees that Kanda shall be entitled to the remedies of specific performance, injunction, and other equitable relief without proof of special damages.',
      ],
      boldFirst: false,
    },
  ],
};
